import {$} from './jquery-definition.js';
import {animateInViewport} from "./transition";

$( function() {
	$( '.load-more' ).click( function( event ) {
		event.preventDefault();
		var $this = $( this );

		var $container = $( $this.attr( 'data-load-more-container' ) );
		$container
			.find( '.hidden-load-more-item' )
			.slice( 0, $this.attr( 'data-load-more-items-per-page' ) )
			.each( function() {
				var $this = $( this );

				$this.removeClass( 'd-none max-md:hidden lg:hidden hidden-load-more-item' );
			} );
		animateInViewport();

		if ( $container.find( '.hidden-load-more-item' ).length === 0 ) {
			$this.addClass( 'd-none' );
		}
	} );

	var $loadMoreTo = $( '*[data-id="' + window.location.hash.substr( 1 ) + '"]' );
	if ( $loadMoreTo.length ) {
		while ( $loadMoreTo.hasClass( 'd-none' ) && !$( '.load-more' ).hasClass( 'd-none' ) ) {
			$( '.load-more' ).click();
		}
		$loadMoreTo.get( 0 ).scrollIntoView();
		setTimeout( function() {
			$( 'html' )
				.removeClass( 'scrolled-up' )
				.addClass( 'scrolled-down' );
		}, 500 );
	}

	$( '.load-more-item' ).click( function( event ) {
		var dataId = $( this ).attr( 'data-id' );
		if ( dataId ) {
			history.replaceState( undefined, undefined, '#' + dataId )
		}
	} );
} );
